import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

export default class PassAttemptStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            [FootballState.PatPass, FootballState.Pass].some(
                (state) => state === fragment.associatedState
            ) &&
            !play.historyContains(FootballState.PassSacked) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: fragment.passedBy.teamId,
            playerId: fragment.passedBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.PASS,
            values: {
                attempted: 1
            }
        });
    }
}
